<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{$t('Transfer-Name-List')}} </v-toolbar-title>
              <v-spacer></v-spacer>
            

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md1>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md1>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>
                      <v-flex xs12 pt-2 sm6 md2>
                        <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  :label="$t('Seller-Code')"
                                  v-model="Satici"
                                ></genelarama>
                      </v-flex>
                      <v-flex xs12 pt-2 sm6 md2>
                        <genelarama
                                  apiname="SaticiAra"
                                  :tip="12"
                                  :label="$t('Tour-Operator')"
                                  v-model="turOperatoru"
                                ></genelarama>
                      </v-flex>
                      <v-flex xs12 sm6 md1 pt-2>
                 
                    <pnrbul 
                      v-model="searchPnrNo"
                      :rules="[(v) => !!v || $t('Mandatory-section')]"
                      hide-details
                    >
                    </pnrbul>
                  
                  
                  </v-flex>
                      <v-flex pt-2>
                        <v-layout row wrap align-center full-heigth>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                         
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headerssatis" :rows-per-page-items="[20,100]" :items="itemssatis"
                                >
                                <template slot="items" slot-scope="props">
                                  <tr @click="git(props.item)" item>
                                    <td class="text-xs-left">{{ props.item.AcenteAd }}</td>
                                    <td class="text-xs-left">{{ props.item.Donem1 }}</td>
                                    <td class="text-xs-left">{{ props.item.SaatStr }}</td>
                                    <td class="text-xs-left">{{ props.item.ADT}}</td>
                                    <td class="text-xs-left">{{ props.item.UcusNo}}</td>
                                    <td class="text-xs-left">{{ props.item.UcusSaatStr  }}</td>
                                    <td class="text-xs-left">{{ props.item.Nerden }}</td>
                                    <td class="text-xs-left">{{ props.item.Nereye}}</td>
                                    <td class="text-xs-left">{{ props.item.PINCode }}</td>
                                    <td class="text-xs-left">{{ props.item.PNR_No  }}</td>
                                    <td class="text-xs-left">{{ props.item.Pax  }}</td>
                                    <td class="text-xs-left">{{ props.item.YetiskinPax }}</td>
                                    <td class="text-xs-right">{{ props.item.Cocuk1Pax }}</td>
                                    <td class="text-xs-center">{{ props.item.Cocuk2Pax }}</td>
                                    <td class="text-xs-right">{{ props.item.Isim  }}</td>
                                    <td class="text-xs-left">{{ props.item.Arac}}</td>
                                    <td class="text-xs-center">{{ props.item.SaticiKod}}</td>
                                    <td class="text-xs-left">{{ props.item.Rehber }}</td>
                                    <td class="text-xs-left">{{ props.item.TurOperatoru }}</td>
                                    <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                                    <td class="text-xs-left">{{ props.item.TurKodu }}</td>

                                    <td class="text-xs-left">{{ props.item.SoforTahsilatTutar }}</td>
                                    <td class="text-xs-left">{{ props.item.strTransferDurumu }}</td>

                                    <td class="text-xs-left">{{ props.item.AracRehber }}</td>
                                    <td class="text-xs-left">{{ props.item.Cari_Kod }}</td>

                                    <td class="text-xs-left">{{ props.item.RezzKod }}</td>
                                    <td class="text-xs-left">{{ props.item.OtelKod }}</td>
                                    <td class="text-xs-left">{{ props.item.OtelAd }}</td>
                                    <td class="text-xs-left">{{ props.item.Ref }}</td>
                                    <td class="text-xs-left">{{ props.item.IslemRef }}</td>
                                  </tr>
                                </template>
                               
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <yetkidialog ref="yetkidialog"></yetkidialog>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogupdate" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Update') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                           
                            <v-flex  xs12 sm12 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="saticiitems"
                                  :label="$t('Seller')"
                                  item-text="isim"
                                  v-model="UpdatePrm.SaticiKod"
                                  item-value="kod"
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex  xs12 sm12 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="otelitems"
                                  :label="$t('Hotel')"
                                  item-text="isim"
                                  v-model="UpdatePrm.OtelKod"
                                  item-value="kod"
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="aracitems"
                                  :label="$t('Transfer-v4')"
                                  item-text="isim"
                                  v-model="UpdatePrm.Arac"
                                  item-value="kod"
                                >
                                </v-autocomplete>
                             
                            </v-flex>
                            

                            <v-flex xs12 sm12 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="rehberitems"
                                  :label="$t('Guide')"
                                  item-text="isim"
                                  v-model="UpdatePrm.Rehber"
                                  item-value="kod"
                                  
                                >
                                </v-autocomplete>
                                
                            </v-flex>

                           

                            <v-flex xs12 sm12 md12>
                              <v-select
                                  hide-details
                                  :items="turkoduitems"
                                  :label="$t('Tour-Code')"
                                  item-text="Aciklama"
                                  item-value="Kod"
                                  v-model="UpdatePrm.Tip"
                                  
                                >
                                </v-select>
                          </v-flex>
                         
                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="UpdatePrm.Saat" :label="$t('Hour')" type="time" :rules="[v => !!v || $t('Mandatory-section')]"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="UpdatePrm.UcusSaat" :label="$t('Flight-Hour')" type="time" :rules="[v => !!v || $t('Mandatory-section')]"></v-text-field>
                          </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>


                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="updateiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="updatekayit()">{{ $t('Apply') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../../api/auth";
  import tarihcomp from "../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import cariaracomp from "@/components/app/customcomp/cariaracomp"
  
  export default {
    data() {
      return {
        itemssatis:[],
        saticiitems:[],
        otelitems:[],
        aracitems:[],
        rehberitems:[],
      
        turkoduitems: [],
        menu1: false,
        UpdatePrm:{
       IslemRef: 0,
  UcusSaat: null,
  Saat: null,
  Rehber: "",
  SaticiKod: "",
  OtelKod: "",
  Arac: "",
  Tip: "",

        },
        PB:'TRY',
        Satici:null,
        tumsirketler:false,
        

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
       
        search: "",
      // "SirketNo": 1,
      // "Tip": null,
      // "TasimaTipi": null,
      // "OdaNo": null,
      // "Acente": null,
     
    
    
     
    
     
     
     
      
     
     

      

        headerssatis: [

       



        {
            text: 'Acente Ad',
            value: "AcenteAd",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Period-v2') + "1",
            value: "Donem1",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Hour'),
            value: "SaatStr",
            width: "5%",
            align: "left"
          },
          {
            text: 'ADT',
            value: "ADT",
            width: "5%",
            align: "left"
          },
          {
            text: 'UcusNo',
            value: "UcusNo",
            width: "5%",
            align: "left"
          },
          {
            text: 'UcusSaatStr',
            value: "UcusSaatStr",
            width: "5%",
            align: "left"
          },
          {
            text: 'Nerden',
            value: "Nerden",
            width: "5%",
            align: "left"
          },
          {
            text: 'Nereye',
            value: "Nereye",
            width: "5%",
            align: "left"
          },
          {
            text: 'PINCode',
            value: "PINCode",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('PNR_No'),
            value: "PNR_No",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Pax'),
            value: "Pax",
            width: "5%",
            align: "left"
          },
          {
            text: 'YetiskinPax',
            value: "YetiskinPax",
            width: "5%",
            align: "left"
          },
          {
            text: 'Cocuk1Pax',
            value: "Cocuk1Pax",
            width: "5%",
            align: "left"
          },
          {
            text: 'Cocuk2Pax',
            value: "Cocuk2Pax",
            width: "5%",
            align: "left"
          },
          {
            text: 'Isim',
            value: "Isim",
            width: "5%",
            align: "left"
          },
          {
            text: 'Arac',
            value: "Arac",
            width: "5%",
            align: "left"
          },
          {
            text: 'SaticiKod',
            value: "SaticiKod",
            width: "5%",
            align: "left"
          },
          {
            text: 'Rehber',
            value: "Rehber",
            width: "5%",
            align: "left"
          },
          {
            text: 'TurOperatoru',
            value: "TurOperatoru",
            width: "5%",
            align: "left"
          },
          {
            text: 'Aciklama',
            value: "Aciklama",
            width: "5%",
            align: "left"
          },
          
          {
            text: this.$t('Tour-Code'),
            value: "TurKodu",
            width: "5%",
            align: "left"
          },
        
          {
            text: 'SoforTahsilatTutar',
            value: "SoforTahsilatTutar",
            width: "5%",
            align: "left"
          },
          {
            text: 'strTransferDurumu',
            value: "strTransferDurumu",
            width: "5%",
            align: "left"
          },
          {
            text: 'AracRehber',
            value: "AracRehber",
            width: "5%",
            align: "left"
          },
          {
            text: 'Cari_Kod',
            value: "Cari_Kod",
            width: "5%",
            align: "left"
          },
          {
            text: 'RezzKod',
            value: "RezzKod",
            width: "5%",
            align: "left"
          },
       
          {
            text: this.$t('Hotel-Code'),
            value: "OtelKod",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Hotel-Name'),
            value: "OtelAd",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Ref'),
            value: "Ref",
            width: "5%",
            align: "left"
          },
         
          {
            text: this.$t('Process-Ref'),
            value: "IslemRef",
            width: "10%",
            align: "left"
          },
         
         
         
         
        
         
        
        ],
       
       
        searchPnrNo:null,
        turOperatoru:null,
        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        SaticiKodu:null,
      
        valid: true,
      
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",
        renk1: "info",
        dialogupdate: false,
        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,

    mounted() {

      this.getOtelItems();
      this.getSaticiItems();    
 this.getaracItems(); 
 this.getrehberItems();

      
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      var credentials = JSON.parse(
       window.localStorage.getItem("credentials")
    );
    this.PB=credentials.ParaBirimi;
    this.$validator.localize("en", this.dictionary);
           
            var credentials = JSON.parse(window.localStorage.getItem("credentials"));

            var params = {
              CompanyCode: credentials.SirketKodu
            };

            this.$http
              .post(auth.API_URL + "api/currency/List", params, {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader()
                }
              })
              .then(
                response => {
                  this.doviztipi = response.body;
                },
                response => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  } else {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  }
                }
              );

           
    },





    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      anatip,
      genelarama,
      referansmerkezicomp,
      pnrbul,
      cariaracomp
    },
    watch: {},
    methods: {
      getaracItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 2,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.aracitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getrehberItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 6,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.rehberitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getOtelItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 1,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.otelitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
      getSaticiItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 2,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.saticiitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
      turkodugetir(SaticiKod) {
      var params = {
        SaticiKodu: SaticiKod,
      };

      tool.http_post(this, "AcenteTurlar", params).then(
        (response) => {
          this.turkoduitems = response.body.data;
        },
        (response) => {
          this.text1 = this.$t('Location-could-not-found-error-occured');
          this.snackbar = true;
        }
      );
    },
updateiptal()
{
this.dialogupdate=false;
},
updatekayit()
{
  
 
  

 if (this.UpdatePrm.Tip=="")
 {
  this.UpdatePrm.Tip=null;
 }
 if (this.UpdatePrm.OtelKod=="")
 {
  this.UpdatePrm.OtelKod=null;
 }
 if (this.UpdatePrm.Arac=="")
 {
  this.UpdatePrm.Arac=null;
 }
 if (this.UpdatePrm.Rehber=="")
 {
  this.UpdatePrm.Rehber=null;
 }
 if (this.UpdatePrm.Saat=="")
 {
  this.UpdatePrm.Saat=null;
 }
 if (this.UpdatePrm.UcusSaat=="")
 {
  this.UpdatePrm.UcusSaat=null;
 }

      tool.http_post(this, "TransferIsimListesiUpdateControl", this.UpdatePrm).then(
        (response) => {
          this.dialogupdate=false;
          this.getList();
        },
        (response) => {
          this.text1 = this.$t('Location-could-not-found-error-occured');
          this.snackbar = true;
        }
      );


},
      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },

      git(val) {
  

 this.UpdatePrm.IslemRef=val.IslemRef;
 this.UpdatePrm.Saat=val.SaatStr;
 this.UpdatePrm.Tip=val.TurKodu;
 this.UpdatePrm.OtelKod=val.OtelKod;
 this.UpdatePrm.Arac=val.Arac;
 this.UpdatePrm.Rehber=val.Rehber;
 this.UpdatePrm.SaticiKod=val.SaticiKod;
        this.turkodugetir(val.SaticiKod);
        this.dialogupdate = true;
        
      },
      getList: getList,
      getListExcel,
      
    }
  };


  

  function getList() {
    




    var saticiprm=null;
      if (this.Satici!=null)
      {
         saticiprm=this.Satici.kod;
      }
      var operatorprm=null;
      if (this.turOperatoru!=null)
      {
        operatorprm=this.turOperatoru.kod;
      }
    let params = {
        Tarih1: this.KayitTarihiBasla,
        Tarih2: this.KayitTarihiBitis,
        SaticiKod: saticiprm,
        OperatorKod: operatorprm,
        PNR_No: this.searchPnrNo,
      };
      
console.log(params);

      this.progress = true;
      this.load1 = false;
       
 
        tool.http_post(this, "TransferIsimListesi", params).then(
          response => {
            // if (response.body.Status == true) {
            //   this.itemssatis = response.body.data;
            //   this.progress = false;
            //   this.load1 = true;
            // } else {
            //   this.text1 = response.body.ErrorList[0];
            //   this.snackbar = true;
            //   this.progress = false;
            //   this.load1 = true;
            // }

            if (response.body.Status == true) {
            console.log("TransferIsimListesi response :");
            console.log(response.body);
            this.itemssatis = response.body.data;
            this.progress = false;
            this.load1 = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          }


          },
          response => {
            this.HataYonetimi(response, params, 'Günlük Tur Listesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
    
  }
  function TransferIsimListesiUpdateControl() {
//Örnek Request
let params={
  "IslemRef": 26070,
  "UcusSaat": "2025-03-04T10:04:54.2891435+03:00",
  "Saat": null,
  "Rehber": "",
  "SaticiKod": "TRANSFER1",
  "OtelKod": "",
  "Arac": "ana2",
  "Tip": "BBBB",
}
tool.http_post(this, 'TransferIsimListesiUpdateControl',params).then(
response => {
if (response.body.Status == true)
{
console.log('TransferIsimListesiUpdateControl response :');
console.log(response.body);
}
else
{
this.text1 = response.body.ErrorList[0]
  this.snackbar = true
}
},
response => {
this.text1 = 'Hata Oluştu, tekrar deneyiniz'
this.snackbar = true
}
);
}
  function getListExcel() {
      var saticiprm=null;
      if (this.Satici!=null)
      {
         saticiprm=this.Satici.kod;
      }
      var operatorprm=null;
      if (this.turOperatoru!=null)
      {
        operatorprm=this.turOperatoru.kod;
      }
    let params = {
        Tarih1: this.KayitTarihiBasla,
        Tarih2: this.KayitTarihiBitis,
        SaticiKod: saticiprm,
        OperatorKod: operatorprm,
        PNR_No: this.searchPnrNo,
      };

      tool.api_post_FileDownload(this, "Coper/ExcelTransferIsimListesi", params).then(
        (response) => {
          tool.CreateDownloadLink(response, "ExcelTransferIsimListesi.xlsx");
        },
        (response) => {
        }
      );

     
  }

  function beforeMount() {}
</script>
<style>
</style>